// @noflow
import { ClientInitQuery, ShippingCountry } from '@/gql/graphql'
import { ReactiveVar, makeVar } from '@apollo/client'

import { SubscriptionStatus } from '@/types/index'

type DynamicDefaultTrackEventProperties = {
  subscription_id?: string
  subscription_status?: SubscriptionStatus
  deliveries_received?: number
  has_puppy?: boolean
  has_fussy_eater?: boolean
}

type DogInfo = {
  dogs: ClientInitQuery['user']['dogs']
  pronoun: 'male' | 'female' | 'plural'
  possessive: Record<string, string>
  has_puppy: boolean
  has_fussy_eater: boolean
}

type DeliveryFeeVar = {
  nonCoreOrderDeliveryFee: number
  nonCoreOrderSmallOrderFee: number
  nonCoreOrderSmallOrderMinimumOrderValue: number
}

type ShippingCountryVar = Pick<
  ShippingCountry,
  '__typename' | 'code' | 'showExtras' | 'showCare' | 'defaultLanguage'
>

type UserVar = ClientInitQuery['user']

type SubscriptionVar = ClientInitQuery['user']['subscription']

const dynamicDefaultTrackEventPropertiesVar: ReactiveVar<DynamicDefaultTrackEventProperties | null> =
  makeVar<DynamicDefaultTrackEventProperties | null>(null)

const userDataVar: ReactiveVar<UserVar | null> = makeVar<UserVar | null>(null)

const dogsDataVar: ReactiveVar<DogInfo | null> = makeVar<DogInfo | null>(null)

const subscriptionDataVar: ReactiveVar<SubscriptionVar | null> =
  makeVar<SubscriptionVar | null>(null)

const shippingCountryDataVar: ReactiveVar<
  ShippingCountryVar | null | undefined
> = makeVar<ShippingCountryVar | null | undefined>(null)

const featureFlagsDataVar: ReactiveVar<Record<
  string,
  string | null | undefined
> | null> = makeVar<Record<string, string | null | undefined> | null>(null)

const hasNotificationsVar: ReactiveVar<boolean> = makeVar<boolean>(false)

const settingsVar: ReactiveVar<Record<string, boolean>> = makeVar<
  Record<string, boolean>
>({})

const orderDeliveryFeeVar: ReactiveVar<DeliveryFeeVar> =
  makeVar<DeliveryFeeVar>({
    nonCoreOrderDeliveryFee: 0,
    nonCoreOrderSmallOrderFee: 0,
    nonCoreOrderSmallOrderMinimumOrderValue: 0
  })

export type {
  DynamicDefaultTrackEventProperties,
  DogInfo,
  ShippingCountry,
  SubscriptionVar
}

export {
  dynamicDefaultTrackEventPropertiesVar,
  dogsDataVar,
  userDataVar,
  subscriptionDataVar,
  shippingCountryDataVar,
  featureFlagsDataVar,
  hasNotificationsVar,
  settingsVar,
  orderDeliveryFeeVar
}
